import React from 'react'
import { CFView, DefaultScreen, MobileScreen } from 'components'
import { contactbg, mobileContactbg } from 'images'
import RestaurantDetails from './RestaurantDetails'
import Hours from './Hours'
import Map from './Map'
import SocialMedia from './SocialMedia'
import DownloadApp from './DownloadApp'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <Map />
          <CFView
            column
            center
            w="100%"
            pv="30px"
            image={`url(${mobileContactbg}) center / cover no-repeat`}
          >
            <CFView w="100%" column center>
              <RestaurantDetails />
              <Hours />
              <DownloadApp />
              <SocialMedia />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center>
          <Map />
          <CFView
            mt="-5px"
            w="100%"
            row
            center
            image={`url(${contactbg}) right / cover no-repeat`}
          >
            <CFView row center bg="rgba(0,0,0,.4)" w="100%" pv="50px">
              <CFView row justifyAround w="100%" maxWidth="1150px" ml="50px">
                <DownloadApp />
                <CFView column>
                  <RestaurantDetails />
                  <SocialMedia />
                </CFView>
                <Hours />
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
